/* eslint-disable jsx-a11y/anchor-is-valid */
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Tag } from "antd";
import React, { useState, useEffect } from "react";
import { repeatObjects, showHideInput } from "../../../View/helper";
import { getInputLabel } from "../../helper";
import { useTranslation } from "react-i18next";
import { getSelectOptions, propHasValue } from "../../../../components/DynamicFormNew/helper";
import { Image } from 'antd';
import dayjs from "dayjs";

export function View({
  formConfig,
  data,
  title = null,
  allData = {},
  checkForAutomaticallyLink = () => { }
}) {
  const excludedKeys = [
    'id',
    'userId',
    'position',
    'authorId',
    'label',
    'outputLabel',
    'icon',
    'sectionLabel',
    'formDescription',
    'introText',
    'formClass',
    'alertConf',
    'showFormIf',
  ];
  const [form, setForm] = useState({});
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const { t } = useTranslation();
  const mapFormGroup = (f) => Object.keys(f).map(key => {
    const { label, ...otpions } = f[key];
    return {
      key,
      label,
      otpions,
    };
  });

  useEffect(() => {
    const groupForm = mapFormGroup(formConfig);
    if (groupForm.length > 0) {
      setForm(groupForm[0]);
    }
  }, [formConfig]);

  const placeholder = (item, config) => {
    return config.noValue
      ? <span className="text-muted">{config.noValue}</span>
      : <span className="text-muted">No Value</span>;
  }

  const select = (item, config, name, formsValue) => {
    let option = config.options
      .find(opt =>
        opt.value === (item ? item[name] : data[name]));
    if (option) {
      option = getSelectOptions(option, formsValue)
    }
    return option && option.label
      ? option.label
      : placeholder(item || data, config)
  }

  const multiselect = (item, config, name, formsValue) => {
    const options = config.options
      .filter(opt => ((item ? item[name] : data[name]) || []).includes(opt.value));
    return options && options.length > 0 ? options.map(opt => {
      opt = getSelectOptions(opt, formsValue)
      return (
        <Tag>{opt.label}</Tag>
      )
    }) : placeholder(item || data, config);
  }

  const ajaxSelect = (item, config, name) => {
    let option;
    const linkConfig = config.dataLink ? config.dataLink : (config.dataView ? config.dataView : {});
    if (linkConfig && linkConfig.formNamespace) {
      const [, , mapper] = config.call.split('::');
      const linkingData = item.linking
        ? item.linking[linkConfig.formNamespace] : null;
      let inputData;
      if (name !== 'parent') {
        inputData = linkingData
          ? linkingData[item ? item[name] : data[name]]
          : null;
      } else {
        inputData = item ? item : data;
      }
      option = Object.keys(JSON.parse(mapper))
        .reduce((opt, key) => {
          opt[key] = inputData ? inputData[JSON.parse(mapper)[key]] : null;
          return opt;
        }, {});
    }
    return option && option.label
      ? option.label
      : 'Not found'
  }

  const value = (item, input, name) => {
    switch (input.type) {
      case 'text':
      case 'phoneNumber':
      case 'number':
      case 'textarea':
        return item
          ? (item[name] ? item[name] : placeholder(item, input))
          : (data[name] ? data[name] : placeholder(data, input));
      case 'percentage':
        return item
          ? (item[name] ? item[name] + '%' : placeholder(item, input))
          : (data[name] ? data[name] + '%' : placeholder(data, input));
      case 'select':
        return select(item, input, name, data);
      case 'ajaxSelect':
        return ajaxSelect(item, input, name);
      case 'switch':
        return item && propHasValue(item[name])
          ? t(item[name] ? 'Yes' : 'No')
          : t(data[name] ? 'Yes' : 'No');
      case 'multiselect':
        return multiselect(item, input, name, data);
      case 'date':
        return item
          ? (item[name] ? dayjs(item[name]).format('DD MMM YYYY').toString() : t('No Date'))
          : (data[name] ? dayjs(data[name]).format('DD MMM YYYY').toString() : t('No Date'));
      case 'group':
        return repeatObjects(input.groupInputs, (key, i) => {
          const first = i === 0;
          return item
            ? (item[key] ? item[key] : (first ? placeholder(item, input) : ''))
            : (data[key] ? data[key] : (first ? placeholder(data, input) : ''))
        });
      case 'geolocation':
        return <a href="#">{t('View on map')}</a>
      case 'imageUpload': 
        const fileList = item &&
          item.pictures ? (Array.isArray(item.pictures) ? item.pictures : (Array.isArray(item.pictures.fileList) ? item.pictures.fileList : [])) : [];
        
        const allImages = fileList.map(v => {
            const img = v.response ? v.response : v;
            img.title = item.title;
            img.description = item.dscription;
            return img;
        }).filter(v => v.url);
        
        return <Image.PreviewGroup>
          {allImages.map((i, k) => (
            <Image
              alt={i.title}
              placeholder={i.title}
              about={i.description}
              key={k}
              width={100}
              src={i.url}
            />
          ))}
        </Image.PreviewGroup>
      case 'upload':
        const documents = item.documents || [];
        try {
          return documents.map(tag => {
            return <a href={tag.url} target="_blank" rel="noreferrer">
              <Tag style={{ width: '100%' }}>{tag.name}</Tag></a>
          });
        } catch (e) {
          console.log(e);
          return '';
        }
      default:
        return input.type;
    }
  }
  return <div className="ajax-modal-view">
    <div className="d-flex justify-content-between remove-button-row"><span>{title}</span><span>
      <Popconfirm
        title={t('unlinkData')}
        open={deleteConfirmVisible}
        onConfirm={checkForAutomaticallyLink}
        onCancel={() => {
          setDeleteConfirmVisible(false);
        }}>
        <Button type="link" onClick={() => {
          setDeleteConfirmVisible(true)
        }} block danger icon={<DeleteOutlined />}>
          {t('Remove')}
        </Button>
      </Popconfirm>
    </span></div>
    {form && form.otpions
      ? Object.keys(form.otpions).filter(key => (showHideInput(form.otpions[key], data) && !excludedKeys.includes(key)) || key === 'datastakeId').map((key, i) => {
        const input = form.otpions[key];
        return <div key={i} className={`${i % 2 === 1 ? 'even' : ''} link-row row`}>
          <span>{getInputLabel(input, data)}</span> <span>{value(data, input, key)}</span>
        </div>
      }) : null}
  </div>
};
